const credentialAuthRoutes = [
  {
    path: '/auth/access-unavailable',
    name: 'auth-access-unavailable',
    component: () => import('@/features/auth/components/AuthAccessUnavailableView.vue'),
    meta: { moduleTag: 'auth', pageTag: 'auth_access_unavailable' },
  },
  {
    path: '/auth/login',
    name: 'auth-login',
    component: () => import('@/features/auth/components/AuthLoginView.vue'),
    meta: {
      authScreen: true,
      moduleTag: 'auth',
      pageTag: 'auth_login',
    },
  },
  {
    path: '/auth/change-password',
    name: 'auth-change-password',
    component: () => import('@/features/auth/components/AuthChangePasswordView.vue'),
    meta: {
      requiresAuth: true,
      moduleTag: 'auth',
      pageTag: 'auth_change_password',
    },
  },
];

export default credentialAuthRoutes;
